// extracted by mini-css-extract-plugin
export default {"slideContainer":"a58d120547 _64d19ec007 _98ab6f9ae3","slideImage":"_729477c82c"};